<template>
    <div class="responsive-page">
        <img src="../assets/logo_blanc.svg" alt="logo" class="logo responsive-logo">
        <!-- Greetings div -->
        <div class="welcome">
            <h2>Bonjour cher {{consultation.referent}},</h2>
            <p>
                Votre parent <b>{{consultation.patient}}</b> vous invite à payer sa consultation.
            </p>
        </div>
        <!-- Informations div -->
        <div class="infos-div">
            <infos :consultation="consultation"/>
        </div>
        <!-- Payment handling div -->
        <div class="payment-div">
            <!-- <span class="payment-label">Méthode de paiement</!-->
            <payment-form 
            :cout="consultation.cost" 
            :patient="consultation.patient" 
            :numberConsultation="consultation.numberConsultation" 
            :noData="noData"
            :enableMobileMoney="enableMobileMoney"
            :fraisTransaction="consultation.fraisTransaction"
            :referent="consultation.referent"
            :referentPhone="consultation.referentPhone"
            />
        </div>
    </div>
</template>

<script>
import infos from './InfosRdvResponsive'
import paymentForm from './PaymentForm'
import httpcli from 'axios'

export default {
    data() {
        return {
            consultation: '',
            noData: false,
            enableMobileMoney: false
        }
    },
    components: {
        infos,
        paymentForm
    },
    created: function() {
        /* Load informations from the database using
         the given code if it is still available*/
        const infosgetter = httpcli.create({
        baseURL: endpoint,
        timeout: 5000,
        headers: {
            'Content-Type':'application/json',
            'x-app-key': '2f9ca294-94b5-4382-a70d-c8770765d496'
        }
        });
        const code = this.$route.params.code
        
        code && infosgetter.get(`/rdv/code/${code}`)
        .then( (response) => {
            let d = response.data.data.data
            if (d !== 'code already used') {
                
                d.dateRdv = moment(d.dateRdv).format("DD MMM  YYYY à  kk:mm")
                d.fraisTransaction = Math.round(d.cost * 0.03)
                d.numberConsultation = d.consultation
                this.consultation = d
                this.$emit('good-code')
            } else {
                this.noData = true
            }
        })
        .catch(function (error) {
            console.error("Payment infos fetching error" + error);
        });

        /* Check the client country using his ip address */

        httpcli.get('https://api.ipgeolocation.io/ipgeo?apiKey=e29f1d5ff99f4eb793ca0ba02df17f3e')
        .then((json) => {
            let country_name = json.data.country_name
            // console.log('from created country name',country_name)
             if (country_name === 'Benin') {
              this.enableMobileMoney = true
            }
        })
        .catch(function (error) {
            console.error(`Error from freegeoip ${error}`)
        })
         
    }
}
</script>

<style>
/* Global styles */
.responsive-page {
    /* min-height: 100vh; */
    width: 100vw;
    background-image: url('../assets/background.svg');
    background-repeat: no-repeat;
    background-position: 0 -1px;
    background-size: 100vw;
}
.logo {
    margin-top: 1.5em;
    margin-left: -0.2em;
}

/* Greetings div styles */
.welcome {
    color: #fff;
}
.welcome h2,p {
    margin: 0.5em 0;
}
.welcome p {
    width: 60%;
    margin: auto !important;
}

/* Informations div styles */
.infos-div {
    width: 80%;
    margin: auto;
    margin-top: 1em;
    /* height: 20vh; */
}

/* Payment handling div styles */
.payment-div {
    width: 80%;
    margin: auto;
    margin-top: 2rem;
}
.payment-label {
    font-weight: bold;
    color: #000;
}
@media screen and (min-width:992px) {
    .responsive-logo {
        display: none;
    }
    .welcome h2 {
        padding-top: 10px;
    }
    .responsive-page {
    background-position: 0 -50px;
}
}
</style>
